import { render, staticRenderFns } from "./ProfessionCrudModal.vue?vue&type=template&id=4267043b&"
import script from "./ProfessionCrudModal.vue?vue&type=script&lang=js&"
export * from "./ProfessionCrudModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports